<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/YAyFHR/Images/cover.jpg?1685327561701" alt="This image is the cover for the book Anthony & Leo, Frankie's Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Anthony & Leo, Frankie's Series
      </h1>
      <p class="bookDescription body article font2">
        <p><b><i>A Novella in Frankie's Series</i></b></p><p>Watching Marchant train his new sub leaves Tony unhappy at not having found a Dom of his own. Running Marchant’s BDSM club, Tony sees who the Doms prefer and it isn’t him—too big, too old, and too hairy. When his friend Jordan suggests he look outside the club, Tony’s mind turns to Leo, a man he met in a traffic jam. Tony manages to arrange a date and happily learns Leo is funny, very toppy, and not averse to Tony's lifestyle. As a bonus, Leo sells sex toys.</p> <p>When tragedy strikes the club, Tony fears he can’t help the mourning club members, but Leo offers his unwavering support. After such a tough start, Tony believes Leo is the Dom he’s been looking for... until he catches him kissing another man.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sue Brown
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?41eadc1d